<template>
  <div class="row border-bottom border-2 border-gray-200 mt-4 py-3">
    <InputAmount
       containerClass="col-12 mb-7"
       :label="$t('payslip.label.incomeAmount')"
       labelClass="form-label fs-6 text-black"
       :inputClass="'form-control form-control-solid'"
       :number="formData.base_salary"
       :iso="currency"
       :required="true"
       @amount="(val) => formData.base_salary = val"/>
  </div>
  <div class="row border-bottom border-2 border-gray-200 py-3">
    <h2> {{ $t('payslip.title.allowances') }} </h2>
    <PayslipAllowanceForm
        v-for="(allowance, index) in formData.allowances"
        :key="allowance.id + index"
        :id="'payslip-allowance-'+index"
        :index="index"
        :allowance="allowance"
        :currency="currency"
        @delete-row="removeAllowanceRow"
        :base-salary="formData.base_salary"
        :parent-id="parentId"
    />
    <div class="col-12 d-flex justify-content-end align-items-end float-end my-5">
      <div class="justify-content-end align-items-end float-end my-1">
        <a class="btn btn-primary" @click.prevent="addAllowanceRow">
          {{ $t('payslip.new.addAllowance') }}
        </a>
      </div>
    </div>
  </div>
  <div class="row py-3">
    <h2> {{ $t('payslip.title.others') }} </h2>
    <PayslipOtherForm
        v-for="(other, index) in formData.others"
        :key="other.id + index"
        :id="'payslip-other-'+index"
        :index="index"
        :other="other"
        :currency="currency"
        @delete-row="removeOtherRow"
        :base-salary="formData.base_salary"
        :parent-id="parentId"
    />
    <div class="col-12 d-flex justify-content-end align-items-end float-end my-5">
      <div class="justify-content-end align-items-end float-end my-1">
        <a class="btn btn-primary" @click.prevent="addOtherRow">
          {{ $t('payslip.new.addOther') }}
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>

import Input from "@/components/Input.vue";
import {defineProps, ref} from "vue";
import PayslipAllowanceForm from "@/Modules/RH/components/Payslip/PayslipAllowanceForm.vue";
import PayslipOtherForm from "@/Modules/RH/components/Payslip/PayslipOtherForm.vue";
import InputAmount from "@/components/InputAmount.vue";

const props = defineProps({
  parentId: { type: String, required: false },
  currency: {type: String, default: 'CFA'},
  data: {
    type: Object,
    default: () => ({
      base_salary: '',
      allowances: [
        {
          id: '',
          value: 0,
          edited: false
        }
      ],
      others: [
        {
          id: '',
          value: 0,
          edited: false
        }
      ],
    })
  }
})

const formData = ref(props.data)

const addAllowanceRow = () => {
  formData.value.allowances.push({
    id: '',
    value: 0,
    edited: false
  })
}
const removeAllowanceRow = (index) => {
  if (formData.value.allowances.length > 0) {
    const [allowanceToDelete] = formData.value.allowances.splice(index, 1)
  }
}

const addOtherRow = () => {
  formData.value.others.push({
    id: '',
    value: 0,
    edited: false
  })
}
const removeOtherRow = (index) => {
  if (formData.value.others.length > 0) {
    const [otherToDelete] = formData.value.others.splice(index, 1)
  }
}
</script>

<style scoped>

</style>